import axios from "axios";
import { BASE_API_URL } from "../shared/app-constants";
import { LocalStorageManager } from "../shared/local-storage-manager";

const HttpClient = axios.create({
  baseURL: BASE_API_URL,
});

export async function refreshToken() {
  let { refresh_token } = LocalStorageManager.getTokens();

  if (refresh_token) {
    try {
      const { data } = await axios.post(`${BASE_API_URL}/user/refresh`, {
        refresh_token,
      });
      if (data?.data?.access_token) {
        LocalStorageManager.saveTokens(
          data?.data?.access_token,
          data?.data?.refresh_token
        );
        return data.data as { access_token: string; refresh_token: string };
      }
    } catch (e) {
      LocalStorageManager.clearTokens();
    }
  }
  return null;
}

HttpClient.interceptors.request.use(async (request) => {
  let { access_token, refresh_token } = LocalStorageManager.getTokens();
  if (!access_token && refresh_token) {
    const newToken = await refreshToken();
    if (newToken?.access_token) {
      access_token = newToken?.access_token;
    }
  }
  if (access_token) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${access_token}`,
    };
  }
  return request;
});

export default HttpClient;
